export default {
  state: {
    active: '',
    categoryBrands: '',
    categoryOrigins: '',
    filterBrand: '',
    parent: '',
    grandParent: '',
    breadcumbs: [],
    grandParentId: '',
    isLoading: {
      filterByCategory: false,
      products: false,
    },
    queryString: {
      filter_rating: '',
      skip: 0,
      limit: 12,
    },
    products: '',
    showModalFilterSort: false,
    showModalFilterRating: false,
    showModalFilterBrand: false,
    sortText: 'Most Popular',
    stateCategoryActive: {
      grandParent: false,
      parent: false,
      child: false,
    },
    totalProduct: '',
    totalDepartmentItems: '..',
    criteria: {
      filter: {},
      skip: 0,
      limit: 12,
      // sort: '-review_stats.total_reviews',
    },
    criteriass: {
      filter: {},
      skip: 0,
      limit: 12,
      // sort: '-review_stats.total_reviews',
    },
  },
  mutations: {
    setStateCategory(state, stateCategory) {
      // reset
      state.stateCategoryActive.grandParent = false;
      state.stateCategoryActive.parent = false;
      state.stateCategoryActive.child = false;
      // assign new val
      state.stateCategoryActive[stateCategory] = true;
    },
    setDataCategoriesProduct(state, dataProducts) {
      state.products = dataProducts;
    },
    setDataCategoryActive(state, data) {
      state.active = data;
      // state.criteria.filter = { 'categories.id': data._id };
      // state.criteriass.filter = { 'categories.id': data._id };
    },
    setDataCategoryBrands(state, data) {
      state.categoryBrands = data;
    },
    setDataCategoryOrigins(state, data) {
      state.categoryOrigins = data;
    },
    setDataFilterByBrandOnCategoryPage(state, dataFilterBrand) {
      state.filterBrand = dataFilterBrand;
    },
    setDataGrandParent(state, { dataGrandParent, dataParent }) {
      dataGrandParent.listParent = dataParent;

      this._vm.$SO.each(dataGrandParent.listParent, (key, category) => {
        dataGrandParent.listParent[key].showNestedList = false;
        //dataGrandParent.listParent[key].count = '..'

        if (state.active.my_soco_sql_id === category.my_soco_sql_id) {
          dataGrandParent.listParent[key].showNestedList = true;
        }

        this._vm.$SO.each(category.sub_categories, (keySubcategory, subcategory) => {
          if (state.active.my_soco_sql_id === subcategory.my_soco_sql_id) {
            dataGrandParent.listParent[key].showNestedList = true;
          }
        });
      });

      state.grandParent = dataGrandParent;
    },
    setDataTotalDepartmentItems(state, totalItems) {
      state.totalDepartmentItems = totalItems;
    },
    setDataTotalProduct(state, totalProduct) {
      state.totalProduct = totalProduct;
    },
    setDataParent(state, dataParent) {
      state.parent = dataParent;
    },
    setGrandParentId(state, id) {
      state.grandParentId = id;
    },
    setLoadingOnCategoryPage(state, { newVal, stateName }) {
      state.isLoading[stateName] = newVal;
    },
    setModalFilterBrandOnCategoryPage(state, newVal) {
      state.showModalFilterBrand = newVal;
    },
    setModalFilterRatingOnCategoryPage(state, newVal) {
      state.showModalFilterRating = newVal;
    },
    setModalFilterSortOnCategoryPage(state, newVal) {
      state.showModalFilterSort = newVal;
    },
    updateCategoryPageQueryString(state, options) {
      state.queryString[options.name] = options.value;
    },
    updateCountParent(state, { key, newVal }) {
      state.grandParent.listParent[key].count = newVal;
    },
    updateSearchQueryBrands(state, { key, newVal }) {
      state.categoryBrands[key].notInQuery = newVal;
    },
    updateShowNestedParent(state, { key, newVal }) {
      this._vm.$SO.each(state.grandParent.listParent, (key, category) => {
        state.grandParent.listParent[key].showNestedList = false;
      });

      state.grandParent.listParent[key].showNestedList = newVal;
    },
    updateStateListCategoryActive(state) {
      this._vm.$SO.each(state.grandParent.listParent, (key, category) => {
        state.grandParent.listParent[key].showNestedList = false;

        if (state.active.my_soco_sql_id === category.my_soco_sql_id) {
          state.grandParent.listParent[key].showNestedList = true;
        }

        this._vm.$SO.each(category.sub_categories, (keySubcategory, subcategory) => {
          if (state.active.my_soco_sql_id === subcategory.my_soco_sql_id) {
            state.grandParent.listParent[key].showNestedList = true;
          }
        });
      });
    },
    updateSortingDropdownOnCategoryPage(state, newVal) {
      state.sortText = newVal;
    },
    setFilterCriteria(state, params) {
      if (Boolean(params.rating)) {
        params.rating = parseInt(params.rating);
        params['$and'] = [
          { 'review_stats.average_rating': { $gte: params.rating } },
          { 'review_stats.average_rating': { $lte: params.rating + 0.999 } },
        ];
        delete params.rating;
      }

      state.criteria.filter = params;
    },
    setFilterCriteriass(state, params) {
      if (Boolean(params.rating)) {
        params.rating = parseInt(params.rating);
        params['$and'] = [
          { 'review_stats.average_rating': { $gte: params.rating } },
          { 'review_stats.average_rating': { $lte: params.rating + 0.999 } },
        ];
        delete params.rating;
      }

      state.criteriass.filter = params;
    },
    setSortCriteria(state, params) {
      state.criteria.sort = params;
      state.criteriass.sort = params;
    },
    setLimitCriteria(state, params) {
      state.criteria.limit = parseInt(params);
      state.criteriass.limit = parseInt(params);
    },
    setPageCriteria(state, page) {
      state.criteria.skip = (parseInt(page) - 1) * state.criteria.limit;
      state.criteriass.skip = (parseInt(page) - 1) * state.criteria.limit;
    },
    setBreadcumbs(state, data) {
      state.breadcumbs = data;
    },
  },
  actions: {
    getBrandsPerProductOnCategoryPage({ commit }, categoryId) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL.get(`/product/categories/${categoryId}/brands`);
    },
    getCategoryActive({ commit }, { categoryIdParam }) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL
        .get(`/product/categories`, {
          params: {
            filter: {
              my_soco_sql_id: categoryIdParam,
            },
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataCategoryActive', response.data.data[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDetailCategory({ commit, dispatch, state, rootState }, { categoryIdParam }) {
      this._vm.$MS_SOCO_PUBLIC_API_URL
        .get(`/product/categories`, {
          params: {
            filter: {
              my_soco_sql_id: categoryIdParam,
            },
          },
        })
        .then((response) => {
          // let categoryRelation;
          let grandParentId;
          // let grandParentIndex;
          const category = (response.data.data && response.data.data[0]) || {};
          const totalParents = this._vm.$SO.size(category.parents);
          const breadcumbIds = [category._id];

          if (response.status === 200) {
            if (totalParents <= 1) {
              grandParentId = categoryIdParam;
              // categoryRelation = 'grandParent';
              commit('setStateCategory', 'grandParent');
            } else {
              // grandParentIndex = totalParents === 2 ? 0 : 1;
              const getParent = (rootState.header.categoriesOfDepartment || []).find(
                (x) => category.parents.indexOf(x._id) > -1
              );
              if (getParent && this._vm.$SO.size(getParent)) {
                grandParentId = getParent.my_soco_sql_id;
              } else {
                grandParentId = categoryIdParam;
              }

              breadcumbIds.push(...category.parents);

              if (totalParents === 2) {
                // categoryRelation = 'parent';
                commit('setStateCategory', 'parent');
              }
              if (totalParents === 3) {
                // categoryRelation = 'child';
                commit('setStateCategory', 'child');
              }
              // dispatch('getBreadcumbs', {
              //   breadcumbIds,
              // });
            }

            commit('setGrandParentId', grandParentId);
            commit('setDataCategoryActive', category);

            if (
              !this._vm.$SO.size(state.grandParent) ||
              state.grandParent.my_soco_sql_id.toString() !== grandParentId.toString()
            ) {
              dispatch('getGrandParent', {
                grandParentId: category._id,
                isFetchGetParent: true,
              });
              //dispatch('getTotalProductGrandParent', grandParentId)
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGrandParent({ commit, state, dispatch }, { grandParentId, isFetchGetParent = false }) {
      //old api
      //let filter = (/^\d+$/).test(grandParentId)? {"my_soco_sql_id":grandParentId} : { "_id": grandParentId}
      // if (/^\d+$/.test(grandParentId)) {
      //   dispatch('getParent', {
      //     grandParentId: grandParentId,
      //     dataGrandParent: state.active,
      //     isFetchGetParent: isFetchGetParent,
      //   });
      // } else {
      // this._vm.$MS_SOCO_PUBLIC_API_URL
      //   .get(`/product/categories`, {
      //     params: {
      //       filter: { _id: grandParentId },
      //     },
      //   })
      //   .then((response) => {
      //     if (response.status === 200) {
      //       dispatch('getParent', {
      //         grandParentId: grandParentId,
      //         dataGrandParent: response.data.data[0],
      //         isFetchGetParent: isFetchGetParent,
      //       });
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      //new api
      this._vm.$MS_CATALOG_API_URL
        .get(`/v3/categories/children`, {
          params: {
            filter: {
              _id: grandParentId,
              depth: 3,
            },
            fields:
              'name,my_soco_sql_id,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo,is_featured',
            skip: 0,
            limit: 10,
            sort: 'position',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataGrandParent', {
              dataGrandParent: response.data.data,
              dataParent: response.data.data.children,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // }
    },
    getParent({ commit, state, rootState }, { grandParentId, dataGrandParent, isFetchGetParent }) {
      if (!isFetchGetParent) {
        return;
      }
      let dataCategory = dataGrandParent;
      if (state.stateCategoryActive.grandParent === false && state.active) {
        dataCategory = state.active;
      }
      this._vm.$MS_SOCO_PUBLIC_API_URL
        .get(`product/categories/${dataCategory._id}/children`)
        .then((response) => {
          let parentId;

          if (response.status === 200) {
            const result = response.data.data.filter(
              (entry, index) => response.data.data.indexOf(entry) === index && entry.my_sociolla_sql_id
            );
            commit('setDataGrandParent', {
              dataGrandParent: dataCategory,
              dataParent: result,
            });

            if (state.stateCategoryActive.child && !rootState.screen.isDesktop) {
              parentId = state.active.parents[0];
              this._vm.$SO.each(response.data.data, (key, parent) => {
                if (parentId === parent.my_soco_sql_id) {
                  commit('setDataParent', parent);
                  return false;
                }
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBreadcumbs({ commit }, { breadcumbIds }) {
      this._vm.$MS_SOCO_PUBLIC_API_URL
        .get(`/category`, {
          params: {
            filter: { _id: { $in: breadcumbIds } },
            section: 'getBreadcumbs',
            sort: 'my_soco_sql_id',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setBreadcumbs', response.data.data);
          }
        });
    },
    getProductsByCategory({ commit, state }, options) {
      commit('setLoadingOnCategoryPage', {
        stateName: 'products',
        newVal: true,
      });
      this._vm.$MS_CATALOG_API_URL
        .get(`/search`, {
          params: {
            ...state.criteria,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataCategoriesProduct', response.data.data);
            commit('setListProducts', response.data.data);
          } else {
            commit('setDataCategoriesProduct', []);
          }

          commit('setLoadingOnCategoryPage', {
            stateName: 'products',
            newVal: false,
          });
        })
        .catch((error) => {
          console.log(error);
          commit('setLoadingOnCategoryPage', {
            stateName: 'products',
            newVal: false,
          });
          commit('setDataCategoriesProduct', []);
        });
    },
    getTotalProductByCategory({ commit, state }, options) {
      this._vm.$MS_CATALOG_API_URL
        .get(`/search/count`, {
          params: {
            // section: 'getTotalProductByCategory',
            filter: state.criteria.filter,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataTotalProduct', response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // getTotalProductGrandParent ({commit}, departmentId) {
    // 	this._vm.$MS_SOCO_PUBLIC_API_URL
    // 	.get(`/products/count`, {
    // 		params: {
    // 			filter: {
    // 				"categories.my_soco_sql_id": departmentId
    // 			}
    // 		}
    // 	}).then(response => {
    // 		if (response.status === 200) {
    // 			commit('setDataTotalDepartmentItems', response.data.data)
    // 		}
    // 	}).catch((error) => {
    // 		console.log(error)
    // 	})
    // },
    updateFilterCriteria({ commit }, params) {
      commit('setFilterCriteria', {
        ...this.state.category.criteria.filter,
        ...params,
      });
    },
  },
  getters: {},
};
